export function filterToQueryParams(filter: object) {
  const activeFilters = Object.entries(filter)
    .filter(e => typeof e[1] != 'undefined' && e[1] != null)
    .map(e => `${e[0]}=${typeof e[1].toISOString === 'function' ? e[1].toISOString() : e[1]}`);
  return activeFilters.length > 0 ? '?' + activeFilters.reduce((a, b) => `${a}&${b}`) : '';
}
